import { useEffect, useState } from 'react';
import './App.css';

const BRAND = 'Cab Partner';
const EMAIL = 'info@cabpartner.co.uk';
const PHONE = '07882740966';
const WHATSAPP = '447365874733';
const WHATSAPP_DISPLAY = '07365874733';
const ADDRESS = 'Office 20239, 182-184 High Street North, East Ham, London, E6 2JA';

const EXPERIENCE_STATS = [
  { label: 'Partner Fleets', value: 500 },
  { label: 'Years Experience', value: 12, isFeatured: true },
  { label: 'Happy Clients', value: 10000 },
  { label: 'UK Cities Covered', value: 80 },
];

const AIRPORTS = [
  {
    name: 'Heathrow Airport (LHR)',
    desc: 'Cab Partner provides reliable and premium transfer services to and from Heathrow Airport, ensuring a smooth and stress-free journey. Our platform connects you with fully vetted professional drivers and well-maintained vehicles for a premium travel experience. Whether travelling for business or leisure, Cab Partner guarantees dependable airport transportation.',
  },
  {
    name: 'Gatwick Airport (LGW)',
    desc: 'Cab Partner offers efficient and timely cab services to and from Gatwick Airport, making travel simple and convenient. We ensure safe journeys with experienced drivers and comfortable vehicles. Passengers can rely on Cab Partner for hassle-free airport transfers every time.',
  },
  {
    name: 'Manchester Airport (MAN)',
    desc: 'Cab Partner provides professional airport transfer services to Manchester Airport with a focus on comfort and reliability. We ensure on-time pickups and smooth travel for all passengers. Enjoy a relaxed journey with Cab Partner.',
  },
  {
    name: 'Stansted Airport (STN)',
    desc: 'Cab Partner delivers dependable transfer services to Stansted Airport, ensuring timely and stress-free travel. We use experienced drivers and modern vehicles for a comfortable ride. Travel confidently with Cab Partner.',
  },
  {
    name: 'Luton Airport (LTN)',
    desc: 'Cab Partner offers convenient cab services to and from Luton Airport with a strong focus on punctuality. We ensure a safe and comfortable journey for every passenger. Choose Cab Partner for reliable airport transfers.',
  },
  {
    name: 'Birmingham Airport (BHX)',
    desc: 'Cab Partner provides smooth and efficient transfers to Birmingham Airport, ensuring a comfortable travel experience. We focus on timely service and customer satisfaction. Passengers can trust Cab Partner for dependable journeys.',
  },
  {
    name: 'Edinburgh Airport (EDI)',
    desc: 'Cab Partner offers reliable airport transfers to Edinburgh Airport with a focus on comfort and punctuality. We ensure smooth pickups and drop-offs for all travellers. Enjoy stress-free travel with Cab Partner.',
  },
  {
    name: 'Glasgow Airport (GLA)',
    desc: 'Cab Partner provides professional transfer services to Glasgow Airport, ensuring safe and timely journeys. We deliver comfort and reliability with experienced drivers. Travel easily with Cab Partner.',
  },
  {
    name: 'Bristol Airport (BRS)',
    desc: 'Cab Partner offers dependable cab services to Bristol Airport, making airport travel simple and convenient. We ensure a comfortable and smooth journey. Choose Cab Partner for reliable transfers.',
  },
  {
    name: 'Newcastle Airport (NCL)',
    desc: 'Cab Partner provides efficient transfer services to Newcastle Airport, ensuring a stress-free travel experience. We focus on safety, comfort, and punctuality. Passengers can rely on Cab Partner every time.',
  },
  {
    name: 'Liverpool John Lennon Airport (LPL)',
    desc: 'Cab Partner offers reliable airport transfers to Liverpool John Lennon Airport with a focus on comfort and convenience. We ensure smooth and timely travel. Enjoy hassle-free journeys with Cab Partner.',
  },
  {
    name: 'East Midlands Airport (EMA)',
    desc: 'Cab Partner provides professional cab services to East Midlands Airport, ensuring safe and timely transportation. We focus on delivering a smooth and comfortable experience. Travel with confidence using Cab Partner.',
  },
  {
    name: 'Aberdeen Airport (ABZ)',
    desc: 'Cab Partner offers long-distance airport transfer services to Aberdeen Airport with comfort and reliability. We ensure a safe and relaxing journey for all passengers. Trust Cab Partner for dependable travel.',
  },
  {
    name: 'Belfast International Airport (BFS)',
    desc: 'Cab Partner provides efficient and reliable transfers to Belfast International Airport, ensuring a smooth travel experience. We focus on punctual service and passenger comfort. Choose Cab Partner for stress-free journeys.',
  },
  {
    name: 'London City Airport (LCY)',
    desc: 'Cab Partner offers convenient cab services to London City Airport with a focus on speed and reliability. We ensure timely pickups and comfortable rides. Travel easily with Cab Partner.',
  },
];

const SERVICES = [
  {
    title: 'Airport Transfers',
    img: 'Airport Transfers.jpg',
    desc: 'Cab Partner connects you with reliable, on-time airport transfer services across the UK, ensuring passengers reach their destination without stress or delay. Our platform focuses on comfort, punctuality, and a smooth travel experience for both arrivals and departures. With professional drivers, well-maintained vehicles, and real-time flight tracking, Cab Partner makes airport journeys easy, safe, and dependable.',
  },
  {
    title: 'Free Child & Baby Seats',
    img: 'Free Child & Baby Seats.jpg',
    desc: 'Cab Partner offers access to operators who provide free child and baby seat facilities, ensuring safe and secure travel for families with young children. We prioritise passenger safety by connecting you with properly equipped vehicles for infants and kids of all ages. Families can enjoy comfortable and worry-free journeys with Cab Partner.',
  },
  {
    title: 'Meet & Greet Service',
    img: 'Meet & Greet Service.jpg',
    desc: 'Cab Partner provides a professional meet & greet service at airports where drivers warmly welcome passengers upon arrival. Drivers assist with luggage handling and guide passengers smoothly to their vehicles. This service ensures a stress-free, friendly, and welcoming airport experience with Cab Partner.',
  },
  {
    title: '24/7 Cab Service',
    img: '247 Taxi Service.jfif',
    desc: 'Cab Partner operates a 24/7 cab booking platform, allowing passengers to book rides at any time of the day or night. We ensure that transportation is always available, whether it\'s early morning or late-night travel. With round-the-clock service and quick response times, Cab Partner provides maximum convenience and reliability.',
  },
  {
    title: 'Executive & Business Travel',
    img: 'Executive & Business Travel.webp',
    desc: 'Cab Partner offers premium executive and business travel solutions designed for corporate clients and professionals. We ensure privacy, comfort, and high-quality service for meetings, conferences, and official trips. Business travellers rely on Cab Partner for punctual, smooth, and professional travel experiences every time.',
  },
  {
    title: 'City-to-City Transfers',
    img: 'City-to-City Transfers.jpg',
    desc: 'Cab Partner provides reliable city-to-city transfer services across the UK, making intercity travel simple, smooth, and comfortable. We ensure safe long-distance journeys with experienced drivers and well-maintained vehicles. Passengers can travel between cities with confidence, enjoying a relaxed and hassle-free ride.',
  },
  {
    title: 'Minibus & Group Travel',
    img: 'Minibus & Group Travel.jpg',
    desc: 'Cab Partner offers spacious minibus and group travel solutions, perfect for families, events, and group tours. We provide comfortable seating, extra space, and convenience for multiple passengers and luggage. Group travel becomes easy, organised, and enjoyable with Cab Partner.',
  },
  {
    title: 'Wheelchair Accessible Vehicles',
    img: 'Wheelchair Accessible.webp',
    desc: 'Cab Partner provides access to wheelchair accessible vehicles to ensure inclusive and comfortable travel for all passengers. We are committed to supporting passengers with mobility needs through specially designed and equipped vehicles. Everyone can travel safely, comfortably, and independently with Cab Partner.',
  },
  {
    title: 'Pet-Friendly Cab Service',
    img: 'Pet-Friendly Service.jpg',
    desc: 'Cab Partner offers pet-friendly cab services, allowing passengers to travel with their pets comfortably. We ensure a safe, clean, and relaxed environment for both passengers and their furry companions. Pet owners can travel easily without any worries using Cab Partner.',
  },
  {
    title: 'Courier & Parcel Delivery',
    img: 'Courier & Parcel Delivery.webp',
    desc: 'Cab Partner provides fast and secure courier and parcel delivery services for both personal and business needs. We ensure safe handling and timely delivery of packages across cities. Customers trust Cab Partner for quick, reliable, and efficient delivery solutions.',
  },
  {
    title: 'Long Distance Journeys',
    img: 'Long Distance Journeys.webp',
    desc: 'Cab Partner offers long-distance travel services with comfort and safety as top priorities. We use experienced drivers to ensure smooth and enjoyable journeys over long routes. Passengers can relax and enjoy stress-free travel with dependable service.',
  },
  {
    title: 'Easy Online Booking',
    img: 'Easy Online Booking.png',
    desc: 'Cab Partner provides an easy online booking platform, making ride reservations quick and simple. Customers can book cabs within minutes through a user-friendly interface. Convenience, speed, and ease of use are the main focus of Cab Partner.',
  },
  {
    title: 'Secure Online Payments',
    img: 'Secure Online Payments.jpg',
    desc: 'Cab Partner supports secure online payment options for safe and hassle-free transactions. We ensure all payments are protected with advanced security systems and encryption. Customers can pay easily and confidently without any concerns.',
  },
  {
    title: 'Extra Luggage Transfers',
    img: 'Extra Luggage Transfers.jpg',
    desc: 'Cab Partner accommodates extra luggage, making travel easier for passengers with heavy or additional baggage. We provide vehicles with sufficient space to handle all luggage needs comfortably. Passengers can travel stress-free without worrying about space.',
  },
  {
    title: 'Flight Monitoring & Delay Tracking',
    img: 'Flight Monitoring.jpg',
    desc: 'Cab Partner offers real-time flight monitoring to adjust pickup times according to delays or early arrivals. We ensure drivers are always updated with flight schedules for smooth coordination. This service guarantees a stress-free and perfectly timed airport pickup experience.',
  },
];

const getAirportSlug = (name) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const findAirportBySlug = (slug) =>
  AIRPORTS.find((airport) => getAirportSlug(airport.name) === slug);

const getServiceSlug = (title) =>
  title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const findServiceBySlug = (slug) =>
  SERVICES.find((svc) => getServiceSlug(svc.title) === slug);

// â”€â”€â”€ SVG Icons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.3 11.3 0 0 0 3.56.57 1 1 0 0 1 1 1V21a1 1 0 0 1-1 1A18 18 0 0 1 2 4a1 1 0 0 1 1-1h4.27a1 1 0 0 1 1 1c0 1.22.2 2.41.57 3.56a1 1 0 0 1-.24 1L6.6 10.8Z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2C6.6 2 2.2 6.3 2.2 11.62c0 1.96.6 3.78 1.64 5.3L2 22l5.27-1.73a10.03 10.03 0 0 0 4.77 1.2h.01c5.43 0 9.84-4.3 9.84-9.63C21.89 6.3 17.48 2 12.04 2Zm0 17.63c-1.5 0-2.98-.4-4.26-1.17l-.3-.18-3.13 1.03 1.03-3.03-.2-.31a7.53 7.53 0 0 1-1.2-4.05c0-4.17 3.47-7.57 7.75-7.57 4.27 0 7.75 3.4 7.75 7.57 0 4.18-3.47 7.57-7.74 7.57Zm4.14-5.66c-.22-.1-1.31-.64-1.52-.71-.2-.08-.35-.1-.5.1-.15.22-.58.7-.7.84-.13.16-.26.18-.48.06-.22-.1-.94-.34-1.78-1.08-.66-.58-1.1-1.3-1.23-1.52-.13-.22-.01-.33.1-.44.1-.1.22-.26.33-.39.11-.12.15-.22.23-.36.08-.16.03-.28-.02-.4-.05-.1-.5-1.2-.68-1.65-.18-.42-.36-.36-.5-.37h-.43c-.15 0-.39.06-.59.28-.2.22-.78.76-.78 1.85 0 1.1.8 2.15.92 2.3.11.14 1.55 2.44 3.86 3.32.55.24.98.39 1.31.5.55.18 1.04.16 1.43.1.43-.06 1.31-.53 1.5-1.04.2-.5.2-.94.14-1.04-.06-.1-.2-.16-.43-.26Z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3 6h18v12H3V6Zm2 2v.2l7 4.8 7-4.8V8l-7 4.8L5 8Z" />
  </svg>
);

// â”€â”€â”€ Quick Actions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const quickActions = [
  {
    label: 'Call Now',
    subLabel: '24/7 Live Support',
    icon: <PhoneIcon />,
    className: 'action-call',
    href: `tel:${PHONE}`,
  },
  {
    label: 'Get Quotation',
    subLabel: 'Free Estimate',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    className: 'action-quote',
    href: 'https://booktaxinow.co.uk/',
    external: true,
  },
  {
    label: 'Book Now',
    subLabel: 'Instant Confirmation',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    className: 'action-book',
    href: 'https://booktaxinow.co.uk/',
    external: true,
  },
  {
    label: 'Airport Booking',
    subLabel: 'Flight Tracking',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 2.7v3" />
        <path d="M8 2.7v3" />
        <rect x="3.5" y="3.5" width="13" height="13" rx="1.5" />
        <path d="M3.5 8.2h13" />
        <path d="m7.1 11.3 1.7 1.8 3.6-3.7" />
        <path d="M17 17.5l1.5-1.5 1.5 1.5" />
        <path d="M17 21h5" />
      </svg>
    ),
    className: 'action-airport',
    href: 'https://booktaxinow.co.uk/',
    external: true,
  },
];

// â”€â”€â”€ Shared Header â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function SiteHeader({ isMenuOpen, setIsMenuOpen }) {
  return (
    <header className="site-header">
      <div className="container header-content">
        <a className="brand" href="#home" aria-label={`${BRAND} home`}>
          <img
            src={`${process.env.PUBLIC_URL}/images/Parnterlogo.png`}
            alt={BRAND}
            className="brand-logo-img"
          />
          <span className="brand-text">
            <strong>Cab</strong><span className="brand-accent">Partner</span>
          </span>
        </a>

        <button
          className="menu-toggle"
          type="button"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          )}
        </button>

        <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`} aria-label="Main navigation">
          <a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a>
          <a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a>
          <a href="#services" onClick={() => setIsMenuOpen(false)}>Our Services</a>
          <a href="#airport" onClick={() => setIsMenuOpen(false)}>Airport Transfers</a>
          <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
          <a href="#policy" onClick={() => setIsMenuOpen(false)}>Policy</a>
          <a href="#terms" onClick={() => setIsMenuOpen(false)}>T&amp;C</a>
        </nav>

        <a className="header-contact-link" href={`mailto:${EMAIL}`}>
          <span className="header-email-icon"><EmailIcon /></span>
          <span>{EMAIL}</span>
        </a>
      </div>
    </header>
  );
}

// â”€â”€â”€ Shared Footer â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-brand-block">
            <a className="brand footer-brand-link" href="#home" aria-label={`${BRAND} home`}>
              <img
                src={`${process.env.PUBLIC_URL}/images/Parnterlogo.png`}
                alt={BRAND}
                className="brand-logo-img brand-logo-img-footer"
              />
              <span className="brand-text footer-brand-text">
                <strong>Cab</strong><span className="brand-accent">Partner</span>
              </span>
            </a>
            <p>Your trusted business partner for professional cab and transport solutions across the United Kingdom.</p>
            <div className="footer-social-row">
              <a className="footer-social-btn" href={`tel:${PHONE}`} aria-label="Call us"><PhoneIcon /></a>
              <a className="footer-social-btn" href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><WhatsAppIcon /></a>
              <a className="footer-social-btn" href={`mailto:${EMAIL}`} aria-label="Email us"><EmailIcon /></a>
            </div>
          </div>

          <div className="footer-link-group">
            <h4>Quick Links</h4>
            <a href="#home">Home</a>
            <a href="#about">About Us</a>
            <a href="#services">Our Services</a>
            <a href="#airport">Airport Transfers</a>
            <a href="#contact">Contact Us</a>
            <a href="#policy">Privacy Policy</a>
            <a href="#terms">Terms &amp; Conditions</a>
          </div>

          <div className="footer-link-group">
            <h4>Contact</h4>
            <a className="footer-contact-item" href={`mailto:${EMAIL}`}>
              <span className="footer-contact-icon"><EmailIcon /></span>
              <span>{EMAIL}</span>
            </a>
            <a className="footer-contact-item" href={`tel:${PHONE}`}>
              <span className="footer-contact-icon"><PhoneIcon /></span>
              <span>{PHONE}</span>
            </a>
            <a className="footer-contact-item" href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">
              <span className="footer-contact-icon"><WhatsAppIcon /></span>
              <span>{WHATSAPP_DISPLAY}</span>
            </a>
            <div className="footer-contact-item">
              <span className="footer-contact-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/></svg>
              </span>
              <span>{ADDRESS}</span>
            </div>
          </div>

          <div className="footer-link-group">
            <h4>Working Hours</h4>
            <p className="footer-hours-item">
              <span className="footer-hours-day">Mon —“ Fri</span>
              <span className="footer-hours-time">24 / 7</span>
            </p>
            <p className="footer-hours-item">
              <span className="footer-hours-day">Saturday</span>
              <span className="footer-hours-time">24 / 7</span>
            </p>
            <p className="footer-hours-item">
              <span className="footer-hours-day">Sunday</span>
              <span className="footer-hours-time">24 / 7</span>
            </p>
            <p className="footer-hours-item">
              <span className="footer-hours-day">Holidays</span>
              <span className="footer-hours-time">Open</span>
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="copyright">
            Â© {new Date().getFullYear()} <span className="copyright-brand">{BRAND}</span>. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <a href="#policy">Privacy Policy</a>
            <a href="#terms">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

// â”€â”€â”€ Floating Buttons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function FloatingContact() {
  return (
    <div className="floating-contact" aria-label="Quick contact actions">
      <a className="floating-btn floating-whatsapp" href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp">
        <span className="floating-label">Chat with us</span>
        <WhatsAppIcon />
      </a>
      <a className="floating-btn floating-call" href={`tel:${PHONE}`} aria-label="Call now">
        <PhoneIcon />
      </a>
    </div>
  );
}

// â”€â”€â”€ Mobile Call Strip â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function MobileCallStrip() {
  return (
    <a className="mobile-call-strip" href={`tel:${PHONE}`} aria-label={`Call ${PHONE}`}>
      <span className="mobile-call-strip-icon"><PhoneIcon /></span>
      <span>Call Now {PHONE}</span>
    </a>
  );
}

// â”€â”€â”€ Contact Section â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function ContactSection({ title }) {
  return (
    <section className="content-section contact" id="contact">
      <div className="container">
        <p className="section-tag">Contact Us</p>
        <h2>{title || 'Have a question or need a partnership quote?'}</h2>
        <div className="contact-panel">
          <div className="contact-primary">
            <div className="contact-call-icon"><PhoneIcon /></div>
            <div className="contact-main-copy">
              <p className="contact-support-line">We are available 24 hours, 365 days a year.</p>
              <a className="contact-phone-link" href={`tel:${PHONE}`}>Call us anytime at {PHONE}</a>
              <p className="contact-note">Fast support for instant booking and partnership enquiries.</p>
            </div>
          </div>
          <div className="contact-methods">
            <article className="contact-method-card">
              <span className="contact-method-label">Call</span>
              <a href={`tel:${PHONE}`}>{PHONE}</a>
            </article>
            <article className="contact-method-card">
              <span className="contact-method-label">Email</span>
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </article>
            <article className="contact-method-card">
              <span className="contact-method-label">WhatsApp</span>
              <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a>
            </article>
            <article className="contact-method-card">
              <span className="contact-method-label">Address</span>
              <p>{ADDRESS}</p>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}

// â”€â”€â”€ Policy Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ─── About Page ────────────────────────────────────────────────────────────────
function AboutPage({ isMenuOpen, setIsMenuOpen, heroStyle, experienceValues }) {
  return (
    <div className="site-shell">
      <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main>
        <section className="policy-hero" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container">
            <div className="policy-hero-content">
              <p className="hero-kicker">Who We Are</p>
              <h1>About Cab Partner</h1>
              <p className="hero-subtitle">Your trusted UK transport business partner — professional, reliable, available 24/7.</p>
            </div>
          </div>
        </section>

        <section className="content-section">
          <div className="container about-layout">
            <div className="about-main">
              <p className="section-tag">About Us</p>
              <h2>About Cab Partner</h2>
              <p className="about-intro">
                Cab Partner is a leading UK transport solutions platform, connecting businesses, corporate clients, and travellers with a trusted network of professional cab and private hire operators nationwide.
              </p>
              <p>
                We bridge the gap between businesses that require reliable transport and vetted operators who deliver it. Our platform provides seamless booking, account management, and dedicated support — making corporate travel effortless.
              </p>
              <h3>What We Do</h3>
              <p>
                We provide comprehensive B2B transport solutions including corporate accounts, airport transfers, executive travel, event logistics, and wheelchair-accessible travel. Our partner fleet includes Saloon Cars, Executive Cars, MPVs, and 6 to 8-seater minibuses.
              </p>
              <h3>What We Offer</h3>
              <ul className="about-offer-list">
                <li>24/7 service with dedicated account management</li>
                <li>Fully licensed, insured, and DBS-checked operators</li>
                <li>Wheelchair-accessible vehicle options</li>
                <li>Airport transfers for all major UK airports</li>
                <li>Fixed pricing with no surge charges</li>
                <li>Instant booking via web, email, or phone on {PHONE}</li>
              </ul>
            </div>

            <div className="about-blocks">
              <article className="about-card">
                <h3>Our Mission</h3>
                <p>To simplify corporate transport by connecting businesses with premium, reliable cab partners — delivering consistent quality, transparency, and peace of mind on every journey.</p>
              </article>
              <article className="about-card">
                <h3>Our Vision</h3>
                <p>To become the UK’s most trusted and preferred transport partner platform — recognised for operational excellence, innovation, and a client-first approach.</p>
              </article>
              <article className="about-card">
                <h3>Our Values</h3>
                <p>Integrity, reliability, professionalism, and continuous improvement drive everything we do at Cab Partner.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="experience-band" aria-label="Cab Partner highlights">
          <div className="container">
            <p className="experience-label">Our Track Record</p>
            <h2 className="experience-title">Trusted By Businesses Across the UK</h2>
            <div className="experience-grid" role="list">
              {EXPERIENCE_STATS.map((stat, index) => (
                <article
                  className={`experience-card ${stat.isFeatured ? 'experience-card-featured' : ''}`}
                  key={stat.label}
                  role="listitem"
                >
                  <p className="experience-number">{(experienceValues[index] || stat.value).toLocaleString()}+</p>
                  <p className="experience-card-label">{stat.label}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="why-banner">
          <div className="container">
            <div className="why-grid">
              {[
                { title: 'Fully Vetted Partners', desc: 'Every operator in our network is fully licensed, insured, and DBS-checked.' },
                { title: '24/7 Availability', desc: 'Round-the-clock service — early morning, late night, or public holidays.' },
                { title: 'Corporate Solutions', desc: 'Tailored business travel accounts, invoicing, and dedicated account managers.' },
                { title: 'Secure & Transparent', desc: 'Fixed pricing, secure payments, and full booking transparency.' },
              ].map((item) => (
                <div className="why-card" key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="content-section">
          <div className="container">
            <p className="section-tag">Company Information</p>
            <h2>Get in Touch with Cab Partner</h2>
            <div className="policy-contact-box" style={{ marginTop: '1.5rem' }}>
              <p><strong>Cab Partner</strong> — UK Transport Solutions Platform</p>
              <p><strong>Registered Address:</strong> {ADDRESS}</p>
              <p><strong>Email:</strong> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
              <p><strong>Phone:</strong> <a href={`tel:${PHONE}`}>{PHONE}</a></p>
              <p><strong>WhatsApp:</strong> <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a></p>
              <p><strong>Industry:</strong> Private Hire &amp; Corporate Transport (B2B Platform)</p>
              <p><strong>Coverage:</strong> Nationwide — 80+ UK Cities</p>
              <p><strong>Operating Hours:</strong> 24 / 7 / 365</p>
            </div>
          </div>
        </section>

        <ContactSection title="Ready to partner with us?" />
      </main>
      <MobileCallStrip />
      <FloatingContact />
      <SiteFooter />
    </div>
  );
}

function PolicyPage({ isMenuOpen, setIsMenuOpen, heroStyle }) {
  return (
    <div className="site-shell">
      <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main>
        <section className="policy-hero" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container">
            <div className="policy-hero-content">
              <p className="hero-kicker">Legal &amp; Compliance</p>
              <h1>Privacy Policy &amp; Terms</h1>
              <p className="hero-subtitle">Transparency, trust, and data protection at Cab Partner</p>
            </div>
          </div>
        </section>

        <section className="content-section policy-section">
          <div className="container">
            <div className="policy-grid">
              <div className="policy-toc">
                <div className="policy-toc-inner">
                  <h3>Contents</h3>
                  {[
                    ['pol-overview', '1. Overview'],
                    ['pol-data', '2. Data We Collect'],
                    ['pol-cancellation', '3. Cancellation & Refund Policy'],
                    ['pol-use', '4. How We Use Your Data'],
                    ['pol-sharing', '5. Data Sharing'],
                    ['pol-cookies', '6. Cookies'],
                    ['pol-rights', '7. Your Rights'],
                    ['pol-security', '8. Data Security'],
                    ['pol-retention', '9. Data Retention'],
                    ['pol-third', '10. Third-Party Links'],
                    ['pol-terms', '11. Terms of Service'],
                    ['pol-liability', '12. Liability'],
                    ['pol-changes', '13. Changes to Policy'],
                    ['pol-contact', '14. Contact Us'],
                  ].map(([id, label]) => (
                    <a
                      key={id}
                      href={`#${id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }}
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </div>

              <div className="policy-body">
                <div className="policy-last-updated">
                  <span>Last Updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                </div>

                <section id="pol-overview" className="policy-block">
                  <h2>1. Overview</h2>
                  <p>Welcome to <strong>Cab Partner</strong> ("we", "our", "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
                  <p>By accessing or using our platform, you acknowledge that you have read, understood, and agree to be bound by all the terms outlined in this policy. If you do not agree with the terms of this policy, please discontinue use of our site.</p>
                  <p>Cab Partner operates as a business-to-business transport partner platform, facilitating connections between transport operators and corporate clients across the United Kingdom.</p>
                </section>

                <section id="pol-data" className="policy-block">
                  <h2>2. Data We Collect</h2>
                  <p>We may collect the following categories of personal and business information:</p>
                  <ul className="policy-list">
                    <li><strong>Identity Data:</strong> Full name, company name, job title.</li>
                    <li><strong>Contact Data:</strong> Email address, telephone number, postal address.</li>
                    <li><strong>Technical Data:</strong> IP address, browser type and version, time zone settings, browser plug-in types and versions, operating system and platform.</li>
                    <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
                    <li><strong>Transaction Data:</strong> Details about bookings, payments, and services you have used.</li>
                    <li><strong>Marketing &amp; Communications Data:</strong> Your preferences in receiving marketing from us and communication preferences.</li>
                  </ul>
                </section>

                <section id="pol-cancellation" className="policy-block">
                  <h2>3. Cancellation &amp; Refund Policy</h2>
                  <p>To ensure fairness for both our customers and drivers, the following cancellation policy applies to all online bookings made through the Cab Partner platform.</p>

                  <h3 className="policy-sub-heading">3.1 Online Booking Cancellation</h3>
                  <p>Whether your booking has been <strong>paid online</strong> or <strong>not yet paid</strong>, a <strong>40% cancellation charge</strong> will apply if you cancel your booking at any stage after confirmation.</p>

                  <h3 className="policy-sub-heading">3.2 Bookings Made One Week or More in Advance</h3>
                  <p>If you book your journey <strong>one week or more in advance</strong> and your scheduled pickup date/time arrives without cancellation within the required notice period, <strong>no refund will be provided</strong>. It is the customer's responsibility to cancel in sufficient time prior to the journey.</p>

                  <h3 className="policy-sub-heading">3.3 Confirmation Within 24 Hours</h3>
                  <p>If you make a booking <strong>2–3 days before your journey</strong>, you must respond to any booking confirmation or communication from our team within <strong>24 hours</strong>. If no response is received within that time and the booking is subsequently cancelled, a <strong>40% cancellation charge</strong> will apply.</p>

                  <h3 className="policy-sub-heading">3.4 No-Show Policy</h3>
                  <p>If the passenger fails to arrive at the agreed pickup location or does not use the booked service without prior notice, the booking will be treated as a <strong>No-Show</strong>. In such cases, <strong>no refund will be issued</strong> and the full booking amount will be retained.</p>

                  <h3 className="policy-sub-heading">3.5 Refund Processing</h3>
                  <p>Where a refund is applicable under the terms above, it will be processed after deducting any applicable cancellation charges. Refunds are ordinarily processed using the original payment method and may take several business days to appear depending on your payment provider.</p>
                </section>

                <section id="pol-use" className="policy-block">
                  <h2>4. How We Use Your Data</h2>
                  <p>We use the data we collect for the following purposes:</p>
                  <ul className="policy-list">
                    <li>To provide, operate, and maintain our platform and services.</li>
                    <li>To process bookings and manage partnerships with transport operators.</li>
                    <li>To communicate with you, including responding to enquiries and providing customer support.</li>
                    <li>To send you important notices, updates, and administrative information.</li>
                    <li>To send marketing and promotional communications (where you have consented).</li>
                    <li>To comply with legal obligations and enforce our terms.</li>
                    <li>To improve our website, services, and user experience through analytics.</li>
                    <li>To detect, prevent, and address fraud, security breaches, and other harmful activity.</li>
                  </ul>
                </section>

                <section id="pol-sharing" className="policy-block">
                  <h2>5. Data Sharing</h2>
                  <p>We do not sell your personal data to third parties. We may share your information with:</p>
                  <ul className="policy-list">
                    <li><strong>Transport Partners:</strong> Vetted cab and transport operators to fulfil bookings.</li>
                    <li><strong>Service Providers:</strong> IT, payment processing, analytics, and communication service providers.</li>
                    <li><strong>Legal Authorities:</strong> Where required by law, court order, or governmental authority.</li>
                    <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
                  </ul>
                  <p>All third parties are required to maintain the confidentiality of your information and comply with applicable data protection laws.</p>
                </section>

                <section id="pol-cookies" className="policy-block">
                  <h2>6. Cookies</h2>
                  <p>We use cookies and similar tracking technologies to enhance your experience on our website. We use:</p>
                  <ul className="policy-list">
                    <li><strong>Essential Cookies:</strong> Required for the website to function correctly.</li>
                    <li><strong>Analytics Cookies:</strong> To understand how visitors interact with our website.</li>
                    <li><strong>Preference Cookies:</strong> To remember your settings and preferences.</li>
                    <li><strong>Marketing Cookies:</strong> To deliver relevant advertisements.</li>
                  </ul>
                  <p>You can control and manage cookies through your browser settings. Disabling certain cookies may affect website functionality.</p>
                </section>

                <section id="pol-rights" className="policy-block">
                  <h2>7. Your Rights</h2>
                  <p>Under the UK General Data Protection Regulation (UK GDPR), you have the following rights:</p>
                  <ul className="policy-list">
                    <li><strong>Right to Access:</strong> Request a copy of the personal data we hold about you.</li>
                    <li><strong>Right to Rectification:</strong> Request correction of inaccurate or incomplete data.</li>
                    <li><strong>Right to Erasure:</strong> Request deletion of your personal data in certain circumstances.</li>
                    <li><strong>Right to Restrict Processing:</strong> Request restriction of processing of your data.</li>
                    <li><strong>Right to Data Portability:</strong> Request transfer of your data to another controller.</li>
                    <li><strong>Right to Object:</strong> Object to processing of your data for certain purposes.</li>
                  </ul>
                  <p>To exercise any of these rights, please contact us at <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
                </section>

                <section id="pol-security" className="policy-block">
                  <h2>8. Data Security</h2>
                  <p>We implement appropriate technical and organisational security measures to protect your personal data against accidental or unlawful destruction, loss, alteration, unauthorised disclosure, or access. These measures include:</p>
                  <ul className="policy-list">
                    <li>SSL/TLS encryption for data transmission.</li>
                    <li>Access controls and authentication procedures.</li>
                    <li>Regular security assessments and audits.</li>
                    <li>Staff training on data protection and security best practices.</li>
                  </ul>
                </section>

                <section id="pol-retention" className="policy-block">
                  <h2>9. Data Retention</h2>
                  <p>We retain your personal data only for as long as necessary to fulfil the purposes outlined in this policy, unless a longer retention period is required or permitted by law. The criteria include the duration of your relationship with us, legal obligations, and statutes of limitation.</p>
                </section>

                <section id="pol-third" className="policy-block">
                  <h2>10. Third-Party Links</h2>
                  <p>Our website may contain links to third-party websites. We do not control these websites and are not responsible for their privacy statements. We encourage you to read the privacy policy of every website you visit.</p>
                </section>

                <section id="pol-terms" className="policy-block">
                  <h2>11. Terms of Service</h2>
                  <p>By using the Cab Partner platform, you agree to the following terms:</p>
                  <ul className="policy-list">
                    <li>You will provide accurate, current, and complete information during registration and booking.</li>
                    <li>You will not use the platform for any unlawful or fraudulent purpose.</li>
                    <li>You will not attempt to gain unauthorised access to any part of our platform.</li>
                    <li>Cab Partner reserves the right to suspend or terminate access to the platform at our discretion.</li>
                    <li>All intellectual property rights on the platform belong to Cab Partner or its licensors.</li>
                    <li>These terms are governed by the laws of England and Wales.</li>
                  </ul>
                </section>

                <section id="pol-liability" className="policy-block">
                  <h2>12. Liability</h2>
                  <p>To the fullest extent permitted by law, Cab Partner shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the platform. Cab Partner acts as an intermediary platform and takes all reasonable steps to vet and verify our network partners.</p>
                </section>

                <section id="pol-changes" className="policy-block">
                  <h2>13. Changes to Policy</h2>
                  <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page with an updated "Last Updated" date. Your continued use of the platform after changes become effective constitutes your acceptance of the revised policy.</p>
                </section>

                <section id="pol-contact" className="policy-block">
                  <h2>14. Contact Us</h2>
                  <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us:</p>
                  <div className="policy-contact-box">
                    <p><strong>Cab Partner</strong></p>
                    <p>{ADDRESS}</p>
                    <p>Email: <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
                    <p>Phone: <a href={`tel:${PHONE}`}>{PHONE}</a></p>
                    <p>WhatsApp: <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a></p>
                  </div>
                  <p>We will respond to all legitimate requests within 30 days.</p>
                </section>
              </div>
            </div>
          </div>
        </section>

        <ContactSection title="Questions about our policy or services?" />
      </main>
      <MobileCallStrip />
      <FloatingContact />
      <SiteFooter />
    </div>
  );
}

// ─── Terms & Conditions Page ─────────────────────────────────────────────────
function TermsPage({ isMenuOpen, setIsMenuOpen, heroStyle }) {
  return (
    <div className="site-shell">
      <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <main>
        <section className="policy-hero" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container">
            <div className="policy-hero-content">
              <p className="hero-kicker">Legal &amp; Compliance</p>
              <h1>Terms &amp; Conditions</h1>
              <p className="hero-subtitle">Please read these terms carefully before using the Cab Partner platform.</p>
            </div>
          </div>
        </section>

        <section className="content-section policy-section">
          <div className="container">
            <div className="policy-grid">
              <div className="policy-toc">
                <div className="policy-toc-inner">
                  <h3>Contents</h3>
                  {[
                    ['tc-acceptance', '1. Acceptance of Terms'],
                    ['tc-services', '2. Our Services'],
                    ['tc-booking', '3. Booking & Payment'],
                    ['tc-cancellation', '4. Cancellation Policy'],
                    ['tc-obligations', '5. User Obligations'],
                    ['tc-prohibited', '6. Prohibited Activities'],
                    ['tc-ip', '7. Intellectual Property'],
                    ['tc-privacy', '8. Privacy'],
                    ['tc-disclaimer', '9. Disclaimers'],
                    ['tc-liability', '10. Limitation of Liability'],
                    ['tc-indemnity', '11. Indemnification'],
                    ['tc-disputes', '12. Dispute Resolution'],
                    ['tc-law', '13. Governing Law'],
                    ['tc-changes', '14. Changes to Terms'],
                    ['tc-contact', '15. Contact Us'],
                  ].map(([id, label]) => (
                    <a
                      key={id}
                      href={`#${id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      }}
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </div>

              <div className="policy-body">
                <div className="policy-last-updated">
                  <span>Last Updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                </div>

                <section id="tc-acceptance" className="policy-block">
                  <h2>1. Acceptance of Terms</h2>
                  <p>By accessing or using the Cab Partner website and platform ("Service"), you confirm that you are at least 18 years of age, have read and understood these Terms &amp; Conditions, and agree to be bound by them. If you are using the Service on behalf of a business or organisation, you represent that you have the authority to bind that entity to these terms.</p>
                  <p>If you do not agree with any part of these terms, you must not use the Service. Your continued use of the platform after any changes to these terms constitutes acceptance of those changes.</p>
                </section>

                <section id="tc-services" className="policy-block">
                  <h2>2. Our Services</h2>
                  <p>Cab Partner operates as a business-to-business (B2B) transport partner platform connecting corporate clients, event organisers, and transport operators across the United Kingdom. Our services include but are not limited to:</p>
                  <ul className="policy-list">
                    <li>Airport transfers to and from all major UK airports</li>
                    <li>Executive and corporate travel solutions</li>
                    <li>City-to-city and long-distance transfers</li>
                    <li>Group and minibus travel arrangements</li>
                    <li>Wheelchair-accessible vehicle bookings</li>
                    <li>Courier and parcel delivery services</li>
                    <li>24/7 cab service booking and management</li>
                  </ul>
                  <p>Cab Partner acts as an intermediary platform. Actual transport services are delivered by vetted third-party operators within our network. We make every reasonable effort to ensure the quality and reliability of our partners.</p>
                </section>

                <section id="tc-booking" className="policy-block">
                  <h2>3. Booking &amp; Payment</h2>
                  <h3 className="policy-sub-heading">3.1 Making a Booking</h3>
                  <p>Bookings can be made via our website, by telephone at <a href={`tel:${PHONE}`}>{PHONE}</a>, via WhatsApp, or by email at <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. All booking requests are subject to availability and operator confirmation.</p>
                  <h3 className="policy-sub-heading">3.2 Booking Confirmation</h3>
                  <p>A booking is only confirmed once you receive a written or electronic confirmation from Cab Partner. It is your responsibility to check all details in the confirmation and notify us immediately of any errors.</p>
                  <h3 className="policy-sub-heading">3.3 Payment Terms</h3>
                  <p>Payment for services may be made online via our secure payment gateway, by invoice (for corporate accounts), or as otherwise agreed at time of booking. All prices are quoted in British Pounds Sterling (GBP) and are inclusive of applicable taxes unless stated otherwise.</p>
                  <h3 className="policy-sub-heading">3.4 Pricing</h3>
                  <p>Prices are fixed at the time of booking. No surge pricing applies. For corporate accounts, agreed rates are honoured for the duration of the contractual period.</p>
                </section>

                <section id="tc-cancellation" className="policy-block">
                  <h2>4. Cancellation Policy</h2>
                  <p>The following cancellation policy applies to all bookings made through the Cab Partner platform:</p>
                  <ul className="policy-list">
                    <li>A <strong>40% cancellation charge</strong> applies to all cancellations, regardless of whether the booking has been paid online or not.</li>
                    <li>Bookings made one week or more in advance are non-refundable if the journey date passes without prior cancellation.</li>
                    <li>Bookings made 2–3 days before the journey require a response to booking confirmation within <strong>24 hours</strong>; otherwise a 40% charge applies upon cancellation.</li>
                    <li><strong>No-show policy:</strong> If a passenger fails to appear at the agreed pickup point, no refund will be issued and the full booking amount is retained.</li>
                  </ul>
                  <p>Where eligible, refunds are processed back to the original payment method and may take several business days to appear.</p>
                </section>

                <section id="tc-obligations" className="policy-block">
                  <h2>5. User Obligations</h2>
                  <p>By using the Cab Partner platform, you agree to:</p>
                  <ul className="policy-list">
                    <li>Provide accurate, complete, and current information at all times during registration and booking.</li>
                    <li>Notify us promptly of any changes to your contact or payment information.</li>
                    <li>Use the platform only for lawful purposes and in a manner that does not infringe the rights of others.</li>
                    <li>Treat all Cab Partner staff, operators, and drivers with respect and courtesy.</li>
                    <li>Be present at the agreed pickup location at the confirmed time.</li>
                    <li>Not use the platform to arrange transport for illegal purposes or carry prohibited items.</li>
                  </ul>
                </section>

                <section id="tc-prohibited" className="policy-block">
                  <h2>6. Prohibited Activities</h2>
                  <p>You must not:</p>
                  <ul className="policy-list">
                    <li>Use the platform for any fraudulent or unlawful purpose.</li>
                    <li>Attempt to gain unauthorised access to any part of our systems or networks.</li>
                    <li>Reproduce, duplicate, copy, sell, or exploit any part of our platform without express written permission.</li>
                    <li>Transmit any unsolicited advertising or promotional material.</li>
                    <li>Knowingly transmit data, viruses, trojans, or any other malicious or technologically harmful material.</li>
                    <li>Impersonate any person or entity, or falsely state or misrepresent your affiliation with any person or entity.</li>
                  </ul>
                  <p>Cab Partner reserves the right to immediately terminate access to the platform for any violation of these prohibited activities.</p>
                </section>

                <section id="tc-ip" className="policy-block">
                  <h2>7. Intellectual Property</h2>
                  <p>All intellectual property rights in the Cab Partner platform, including but not limited to the website design, logos, trademarks, text, graphics, and software, are owned by Cab Partner or its licensors. Nothing in these terms grants you any right to use the Cab Partner name, logo, or any other intellectual property without prior written permission.</p>
                </section>

                <section id="tc-privacy" className="policy-block">
                  <h2>8. Privacy</h2>
                  <p>Your use of the Cab Partner platform is also governed by our <a href="#policy">Privacy Policy</a>, which is incorporated into these Terms &amp; Conditions by reference. By using the platform, you consent to the collection and use of your data as described in the Privacy Policy.</p>
                </section>

                <section id="tc-disclaimer" className="policy-block">
                  <h2>9. Disclaimers</h2>
                  <p>The Cab Partner platform is provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the platform's availability, accuracy, or fitness for a particular purpose. We do not guarantee uninterrupted access to the platform.</p>
                  <p>While we take all reasonable steps to vet and monitor our transport partners, Cab Partner does not accept responsibility for delays, cancellations, or substandard service caused by third-party operators beyond our reasonable control, including but not limited to traffic conditions, adverse weather, or vehicle breakdowns.</p>
                </section>

                <section id="tc-liability" className="policy-block">
                  <h2>10. Limitation of Liability</h2>
                  <p>To the maximum extent permitted by applicable law, Cab Partner shall not be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, including lost profits, loss of data, or goodwill, arising out of or in connection with your use of or inability to use the platform.</p>
                  <p>Our total liability to you for any claim arising under or in connection with these terms shall not exceed the total amount you have paid to Cab Partner in the twelve (12) months preceding the event giving rise to the claim.</p>
                </section>

                <section id="tc-indemnity" className="policy-block">
                  <h2>11. Indemnification</h2>
                  <p>You agree to indemnify, defend, and hold harmless Cab Partner and its officers, directors, employees, agents, and partners from and against any claims, liabilities, damages, losses, and expenses, including reasonable legal fees, arising out of or in any way connected with your access to or use of the platform, your violation of these terms, or your violation of any third-party rights.</p>
                </section>

                <section id="tc-disputes" className="policy-block">
                  <h2>12. Dispute Resolution</h2>
                  <p>In the event of any dispute, we encourage you to first contact us directly at <a href={`mailto:${EMAIL}`}>{EMAIL}</a> or <a href={`tel:${PHONE}`}>{PHONE}</a> so we can attempt to resolve the matter amicably. If a resolution cannot be reached, disputes will be referred to mediation or arbitration before legal proceedings are initiated, in accordance with the laws of England and Wales.</p>
                </section>

                <section id="tc-law" className="policy-block">
                  <h2>13. Governing Law</h2>
                  <p>These Terms &amp; Conditions are governed by and construed in accordance with the laws of England and Wales. You irrevocably agree that the courts of England and Wales shall have exclusive jurisdiction to settle any dispute or claim arising out of or in connection with these terms or their subject matter or formation.</p>
                </section>

                <section id="tc-changes" className="policy-block">
                  <h2>14. Changes to Terms</h2>
                  <p>Cab Partner reserves the right to update or modify these Terms &amp; Conditions at any time without prior notice. Changes will be effective immediately upon posting on this page with an updated "Last Updated" date. It is your responsibility to review these terms periodically. Your continued use of the platform following any changes constitutes your acceptance of the revised terms.</p>
                </section>

                <section id="tc-contact" className="policy-block">
                  <h2>15. Contact Us</h2>
                  <p>If you have any questions about these Terms &amp; Conditions, please contact us:</p>
                  <div className="policy-contact-box">
                    <p><strong>Cab Partner</strong></p>
                    <p>{ADDRESS}</p>
                    <p>Email: <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
                    <p>Phone: <a href={`tel:${PHONE}`}>{PHONE}</a></p>
                    <p>WhatsApp: <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a></p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>

        <ContactSection title="Questions about our terms or services?" />
      </main>
      <MobileCallStrip />
      <FloatingContact />
      <SiteFooter />
    </div>
  );
}

// â”€â”€â”€ Main App â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function App() {
  const [experienceValues, setExperienceValues] = useState(
    EXPERIENCE_STATS.map(() => 0)
  );
  const [activeHash, setActiveHash] = useState(window.location.hash || '#home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isAirportDetailsPage = activeHash.startsWith('#/airport-details/');
  const selectedAirportSlug = activeHash.replace('#/airport-details/', '');
  const selectedAirport = findAirportBySlug(selectedAirportSlug);

  const isServiceDetailsPage = activeHash.startsWith('#/service-details/');
  const selectedServiceSlug = activeHash.replace('#/service-details/', '');
  const selectedService = findServiceBySlug(selectedServiceSlug);

  const isPolicyPage = activeHash === '#policy';
  const isTermsPage = activeHash === '#terms';
  const isAboutPage = activeHash === '#about';

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/partner2.jpg)`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  useEffect(() => {
    const durationMs = 1400;
    const steps = 45;
    let currentStep = 0;
    const timer = window.setInterval(() => {
      currentStep += 1;
      setExperienceValues(
        EXPERIENCE_STATS.map((stat) =>
          Math.min(stat.value, Math.round((stat.value * currentStep) / steps))
        )
      );
      if (currentStep >= steps) window.clearInterval(timer);
    }, durationMs / steps);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setActiveHash(window.location.hash || '#home');
      setIsMenuOpen(false);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    if (
      activeHash.startsWith('#/airport-details/') ||
      activeHash.startsWith('#/service-details/') ||
      activeHash === '#policy' ||
      activeHash === '#terms' ||
      activeHash === '#about'
    ) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return undefined;
    }
    if (['#airport', '#services', '#contact'].includes(activeHash)) {
      const sectionId = activeHash.replace('#', '');
      const timer = window.setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [activeHash]);

  const renderExperienceBand = (keySuffix) => (
    <section className="experience-band" aria-label="Cab Partner highlights" key={keySuffix}>
      <div className="container">
        <p className="experience-label">Our Track Record</p>
        <h2 className="experience-title">Trusted By Businesses Across the UK</h2>
        <div className="experience-grid" role="list">
          {EXPERIENCE_STATS.map((stat, index) => (
            <article
              className={`experience-card ${stat.isFeatured ? 'experience-card-featured' : ''}`}
              key={stat.label}
              role="listitem"
            >
              <p className="experience-number">{experienceValues[index].toLocaleString()}+</p>
              <p className="experience-card-label">{stat.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );

  // â”€â”€â”€ Policy Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (isPolicyPage) {
    return <PolicyPage isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} heroStyle={heroStyle} />;
  }

  if (isTermsPage) {
    return <TermsPage isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} heroStyle={heroStyle} />;
  }

  if (isAboutPage) {
    return <AboutPage isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} heroStyle={heroStyle} experienceValues={experienceValues} />;
  }

  // â”€â”€â”€ Service Details Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (isServiceDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className="airport-details-main">
          <section className="hero airport-details-home-hero" style={heroStyle}>
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Professional Transport Solutions</p>
                <h1 className="hero-title">{selectedService ? selectedService.title : 'Our Services'}</h1>
                <p className="hero-subtitle">With Cab Partner, available 24/7 across the UK.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a className={`action-card ${action.className}`} href={action.href} key={action.label} role="listitem" target={action.external ? '_blank' : undefined} rel={action.external ? 'noopener noreferrer' : undefined}>
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                    {action.subLabel && <span className="action-sublabel">{action.subLabel}</span>}
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Our Services</p>
              <h1 className="airport-details-title">{selectedService ? selectedService.title : 'Service Not Found'}</h1>
              <a className="airport-back-btn" href="#services">â† Back To Services</a>
              <div className="svc-details-layout">
                {selectedService ? (
                  <>
                    <div className="svc-details-img-wrap">
                      <img src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(selectedService.img)}`} alt={selectedService.title} className="svc-details-img" />
                    </div>
                    <div className="svc-details-body"><p>{selectedService.desc}</p></div>
                  </>
                ) : (
                  <p>The selected service could not be found. Please return to Our Services and choose again.</p>
                )}
              </div>
            </div>
          </section>

          <ContactSection title="Need help booking this service?" />
        </main>
        <MobileCallStrip />
        <FloatingContact />
        <SiteFooter />
      </div>
    );
  }

  // â”€â”€â”€ Airport Details Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  if (isAirportDetailsPage) {
    return (
      <div className="site-shell airport-details-page">
        <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className="airport-details-main">
          <section className="hero airport-details-home-hero" style={heroStyle}>
            <div className="hero-overlay" />
            <div className="container hero-content">
              <div className="hero-intro">
                <p className="hero-kicker">Airport Transfer Partner</p>
                <h1 className="hero-title">{selectedAirport ? selectedAirport.name : 'Airport Transfers'}</h1>
                <p className="hero-subtitle">Professional airport transport, available 24/7.</p>
              </div>
              <div className="quick-actions" role="list">
                {quickActions.map((action) => (
                  <a className={`action-card ${action.className}`} href={action.href} key={action.label} role="listitem" target={action.external ? '_blank' : undefined} rel={action.external ? 'noopener noreferrer' : undefined}>
                    <span className="action-icon">{action.icon}</span>
                    <span className="action-text">{action.label}</span>
                    {action.subLabel && <span className="action-sublabel">{action.subLabel}</span>}
                  </a>
                ))}
              </div>
            </div>
          </section>

          <section className="content-section">
            <div className="container">
              <p className="section-tag">Airport Transfers</p>
              <h1 className="airport-details-title">{selectedAirport ? selectedAirport.name : 'Airport Not Found'}</h1>
              <a className="airport-back-btn" href="#airport">â† Back To Airport List</a>
              <div className="airport-details-list">
                {selectedAirport ? (
                  <article className="airport-details-item">
                    <h2>{selectedAirport.name}</h2>
                    <p>{selectedAirport.desc}</p>
                  </article>
                ) : (
                  <article className="airport-details-item">
                    <h2>Details unavailable</h2>
                    <p>The selected airport could not be found. Please return to the airport transfers section and choose an airport again.</p>
                  </article>
                )}
              </div>
            </div>
          </section>

          <ContactSection title="Need airport booking assistance?" />
        </main>
        <MobileCallStrip />
        <FloatingContact />
        <SiteFooter />
      </div>
    );
  }

  // â”€â”€â”€ Home Page â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  return (
    <div className="site-shell">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container top-bar-content">
          <p>Your Trusted Cab &amp; Transport Business Partner — Across the UK</p>
          <div className="top-bar-right">
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            <span className="top-bar-sep">|</span>
            <a href={`tel:${PHONE}`}>{PHONE}</a>
          </div>
        </div>
      </div>

      <SiteHeader isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      <main>
        {/* Hero */}
        <section className="hero" id="home" style={heroStyle}>
          <div className="hero-overlay" />
          <div className="container hero-content">
            <div className="hero-intro">
              <p className="hero-kicker">Your Trusted Transport Business Partner</p>
              <h1 className="hero-title">Cab Partner Solutions Across the UK</h1>
              <p className="hero-subtitle">Professional. Reliable. Available 24/7 — Connecting Businesses with Quality Transport.</p>
            </div>
            <div className="quick-actions" role="list">
              {quickActions.map((action) => (
                <a className={`action-card ${action.className}`} href={action.href} key={action.label} role="listitem" target={action.external ? '_blank' : undefined} rel={action.external ? 'noopener noreferrer' : undefined}>
                  <span className="action-icon">{action.icon}</span>
                  <span className="action-text">{action.label}</span>
                  {action.subLabel && <span className="action-sublabel">{action.subLabel}</span>}
                </a>
              ))}
            </div>
          </div>
        </section>

        {renderExperienceBand('top')}

        {/* Why Choose Us */}
        <section className="why-banner">
          <div className="container">
            <div className="why-grid">
              {[
                { icon: '', title: 'Fully Vetted Partners', desc: 'Every operator in our network is fully licensed, insured, and DBS-checked.' },
                { icon: '', title: '24/7 Availability', desc: 'Round-the-clock service — early morning, late night, or public holidays.' },
                { icon: '', title: 'Corporate Solutions', desc: 'Tailored business travel accounts, invoicing, and dedicated account managers.' },
                { icon: '', title: 'Secure & Transparent', desc: 'Fixed pricing, secure payments, and full booking transparency.' },
              ].map((item) => (
                <div className="why-card" key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About */}
        <section className="content-section" id="about">
          <div className="container about-layout">
            <div className="about-main">
              <p className="section-tag">About Us</p>
              <h2>About Cab Partner</h2>
              <p className="about-intro">
                Cab Partner is a leading UK transport solutions platform, connecting businesses, corporate clients, and travellers with a trusted network of professional cab and private hire operators nationwide.
              </p>
              <p>
                We bridge the gap between businesses that require reliable transport and vetted operators who deliver it. Our platform provides seamless booking, account management, and dedicated support — making corporate travel effortless.
              </p>
              <h3>What We Do</h3>
              <p>
                We provide comprehensive B2B transport solutions including corporate accounts, airport transfers, executive travel, event logistics, and wheelchair-accessible travel. Our partner fleet includes Saloon Cars, Executive Cars, MPVs, and 6 to 8-seater minibuses.
              </p>
              <h3>What We Offer</h3>
              <ul className="about-offer-list">
                <li>24/7 service with dedicated account management</li>
                <li>Fully licensed, insured, and DBS-checked operators</li>
                <li>Wheelchair-accessible vehicle options</li>
                <li>Airport transfers for all major UK airports</li>
                <li>Fixed pricing with no surge charges</li>
                <li>Instant booking via web, email, or phone on {PHONE}</li>
              </ul>
            </div>

            <div className="about-blocks">
              <article className="about-card">

                <h3>Our Mission</h3>
                <p>To simplify corporate transport by connecting businesses with premium, reliable cab partners — delivering consistent quality, transparency, and peace of mind on every journey.</p>
              </article>
              <article className="about-card">

                <h3>Our Vision</h3>
                <p>To become the UK's most trusted and preferred transport partner platform — recognised for operational excellence, innovation, and a client-first approach.</p>
              </article>
              <article className="about-card">

                <h3>Our Values</h3>
                <p>Integrity, reliability, professionalism, and continuous improvement drive everything we do at Cab Partner.</p>
              </article>
            </div>
          </div>
        </section>

        {/* Services */}
        <section className="content-section services" id="services">
          <div className="container">
            <p className="section-tag">Our Services</p>
            <h2>What We Offer</h2>
            <p className="services-sub">Professional transport solutions available 24/7 across the UK through our trusted partner network.</p>
            <div className="service-grid-pro">
              {SERVICES.map((svc) => (
                <article className="svc-card" key={svc.title}>
                  <div className="svc-img-slot">
                    <img src={`${process.env.PUBLIC_URL}/images/${encodeURIComponent(svc.img)}`} alt={svc.title} className="svc-img" />
                  </div>
                  <div className="svc-body">
                    <h3>{svc.title}</h3>
                    <p>{svc.desc}</p>
                    <a className="airport-read-more" href={`#/service-details/${getServiceSlug(svc.title)}`}>Learn More â†’</a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Airport Transfers */}
        <section className="content-section airport-section" id="airport">
          <div className="container">
            <p className="section-tag">Airport Transfers</p>
            <h2>Reliable Airport Transfer Partners</h2>
            <div className="airport-hero">
              <div className="airport-hero-image-wrap">
                <img src={`${process.env.PUBLIC_URL}/images/Airport%20Transfersslider.jpg`} alt="Cab Partner airport transfer service" className="airport-hero-image" />
              </div>
              <div className="airport-hero-content">
                <p>Cab Partner connects your business with reliable, professional airport transfer operators across the UK, ensuring a smooth and stress-free journey for every passenger. We focus on punctuality — offering on-time pickups and drop-offs so your clients never miss a flight.</p>
                <p>Whether travelling for business or leisure, Cab Partner makes airport transportation simple, convenient, and dependable. We monitor flight schedules to adjust pickup times according to delays or early arrivals, ensuring maximum convenience.</p>
                <a className="airport-cta" href="#contact">Partner With Us</a>
              </div>
            </div>
            <div className="airport-list-grid">
              {AIRPORTS.map((airport) => (
                <article className="airport-item" key={airport.name}>
                  <h3>{airport.name}</h3>
                  <p>{airport.desc}</p>
                  <a className="airport-read-more" href={`#/airport-details/${getAirportSlug(airport.name)}`}>Read More â†’</a>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="content-section testimonials-section">
          <div className="container">
            <p className="section-tag">Client Testimonials</p>
            <h2>What Our Partners Say</h2>
            <div className="testimonials-grid">
              {[
                { name: 'James Thornton', company: 'Thornton Corporate Ltd', text: 'Cab Partner transformed our corporate travel. Consistent quality, professional drivers, and transparent pricing — exactly what a business needs.', rating: 5 },
                { name: 'Sarah Mitchell', company: 'Mitchell Events Agency', text: 'Booking airport transfers for our event delegates has never been easier. The Cab Partner team are responsive and always deliver.', rating: 5 },
                { name: 'David Patel', company: 'Patel & Associates', text: 'A true business partner. Reliable service, competitive rates, and excellent account management. Highly recommended for any corporate client.', rating: 5 },
              ].map((t) => (
                <article className="testimonial-card" key={t.name}>
                  <div className="testimonial-stars">{'\u2605'.repeat(t.rating)}</div>
                  <p className="testimonial-text">"{t.text}"</p>
                  <div className="testimonial-author">
                    <strong>{t.name}</strong>
                    <span>{t.company}</span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <ContactSection />
      </main>

      <MobileCallStrip />
      <FloatingContact />
      <SiteFooter />
    </div>
  );
}

export default App;
